<ul class="menu">
  @for (menuItem of sideNavMenuItems; track $index) {
    <!-- Divider -->
    @if (menuItem.dividerAbove) {
      <li class="px-2">
        <hr class="border-t border-base-300 my-2 pointer-events-none rounded-none" />
      </li>
    }

    <!-- Menu Item -->
    <li>
      <!-- Opens a dialog instead of navigating -->
      @if (menuItem.dialogId) {
        <button
          type="button"
          [attr.data-tour]="'nav-' + menuItem.name"
          (click)="openDialog(menuItem)"
          class="flex w-full items-center px-4 py-2.5 rounded-md hover:bg-base-300 transition-colors"
        >
          <!-- Same inner layout as the links, so the icons and labels line up. -->
          <div class="flex items-center space-x-3 min-w-0">
            @if (getMenuIcon(menuItem.name)) {
              <img [src]="getMenuIcon(menuItem.name)!" [alt]="menuItem.name" class="w-5 h-5 shrink-0 menu-icon" />
            }
            <span class="text-primary truncate">{{ menuItem.name }}</span>
          </div>
        </button>
      }

      <!-- Standard Menu Item (Link/Dropdown) -->
      @if (isStandardMenuItem(menuItem) && !menuItem.dialogId) {
        <a
          [routerLink]="getRouterLink(menuItem)"
          [attr.data-tour]="'nav-' + menuItem.name"
          (click)="handleMenuItemClick(menuItem)"
          [ngClass]="{
            active: isParentActive(menuItem),
            'cursor-pointer': isDropdownType(menuItem),
          }"
          class="flex items-center justify-between px-4 py-2.5 rounded-md hover:bg-base-300 transition-colors"
        >
          <div class="flex items-center space-x-3 min-w-0">
            @if (getMenuIcon(menuItem.name)) {
              <img
                [src]="getMenuIcon(menuItem.name)!"
                [alt]="menuItem.name"
                class="w-5 h-5 shrink-0 menu-icon"
                [ngClass]="{ 'menu-icon-active': isParentActive(menuItem) }"
              />
            }
            <span class="text-primary truncate" [ngClass]="{ 'text-base-content font-bold': isParentActive(menuItem) }">
              {{ menuItem.name }}
            </span>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            @if (isDropdownType(menuItem)) {
              <button
                type="button"
                class="transition-transform duration-200 bg-transparent border-0 p-0"
                [ngClass]="isExpanded(menuItem) ? 'rotate-180' : ''"
                (click)="toggleDropdown(menuItem); $event.stopPropagation(); $event.preventDefault()"
              >
                <svg class="w-3 h-3 text-base-content/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            }
          </div>
        </a>
      }

      <!-- Submenu -->
      @if (shouldShowSubmenu(menuItem)) {
        <ul
          [ngClass]="{
            'ml-8 pl-2 mt-1 space-y-0.5': true,
            'labs-submenu-scrollable': isScrollableSubmenu(menuItem),
          }"
        >
          @for (subItem of menuItem.sub; track $index) {
            @if (isValidSubItem(subItem)) {
              <li>
                <a
                  (click)="onSubItemClick(subItem, $event)"
                  class="flex items-center justify-between px-3 py-1.5 rounded-md hover:bg-base-300 transition-colors cursor-pointer menu-submenu-link"
                  [attr.data-lab-state]="subItem.state"
                  [attr.data-tour-sub]="subItem.name"
                >
                  <span
                    class="text-sm menu-item-text"
                    [ngClass]="{ 'text-primary': !isSelected(subItem), 'text-info font-bold': isSelected(subItem) }"
                    [title]="subItem.name"
                  >
                    {{ subItem.name }}
                  </span>
                </a>
              </li>
            }
          }
        </ul>
      }
    </li>
  }
</ul>
